import { ReactElement } from 'react';
import { ICON_SIZE } from 'utils/constants/app/ui';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { createArray } from 'utils/helpers/create-fake-array';
import { isMobile } from 'utils/is-mobile';
import { MultipleSelectionsCardHeaderSkeleton } from 'newcomponents/Shared/sportsbook/Multiples/MultipleCardHaeder/Skeleton';
import { Skeleton } from 'newcomponents/UI/Skeleton';
import './index.less';

if (SpringConfigs.IS_RTL) {
  import('./rtl.less');
}

const iconSize = isMobile() ? ICON_SIZE.MOBILE_24 : ICON_SIZE.DESKTOP_32;
const SKELTETON_COUNT = 3;

type TDesktopMultipleCardsSkeletonProps = {
  className?: string;
};

export const DesktopMultipleCardsSkeleton = ({
  className = ''
}: TDesktopMultipleCardsSkeletonProps): ReactElement => {
  return (
    <div
      className={`skeletonBlock selectionSkeleton ${className} ${
        SpringConfigs.LEFT_SIDE_BAR
          ? 'multipleNoPadding'
          : 'multipleWithPadding'
      }`}
    >
      {createArray(SKELTETON_COUNT).map((_, index) => (
        <div
          className="skeletonBlock__card skeletonBlock__card--skeleton"
          key={index}
        >
          <MultipleSelectionsCardHeaderSkeleton hideExpireDate />
          {createArray(SKELTETON_COUNT).map((_, index) => (
            <div className="skeletonBlock__card__body" key={index}>
              <div className="skeletonBlock__card__body__title">
                <Skeleton.Avatar
                  className="skeletonBlock__card__body__title__avatar"
                  size={iconSize}
                  active
                />
                <Skeleton paragraph={{ rows: 0 }} active />
              </div>
              <div className="skeletonBlock__card__body__item">
                <Skeleton
                  title={{
                    style: { height: 0, margin: '5px 10px' }
                  }}
                  paragraph={{ rows: 2 }}
                  active
                />
                <Skeleton
                  className="skeletonBlock__card__body__item__data"
                  paragraph={{ rows: 0 }}
                  active
                />
              </div>
            </div>
          ))}
          <div className="skeletonBlock__footer">
            <Skeleton
              title={{
                style: { height: 0, width: 210 }
              }}
              paragraph={{ rows: 2 }}
              active
            />
            <Skeleton.Button active className="skeletonBlock__footer__btn" />
          </div>
        </div>
      ))}
    </div>
  );
};
